// extracted by mini-css-extract-plugin
module.exports = {"root":"LayoutSettings_root__3X5HX","content":"LayoutSettings_content__2Va0T"};